import { apiClient } from 'client/core/network/apiClient';
import { IAuthDomain } from 'common/schema/AuthDomain';

export const AuthDomainApi = {
  findDomains: () => apiClient.get<IAuthDomain[]>(`/auth-domains`)
};
